import React from 'react';
import { useTranslation } from 'react-i18next';
import { Inscription } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';

interface Props {
  lockingLeft?: number;   
  onSetVisible: (value: boolean) => void;
}

const AccountLockoutModal: React.FC<Props> = ({ lockingLeft, onSetVisible }) => {
  const { t } = useTranslation();

  return (
    <WarnModal
      visible
      onSetVisible={onSetVisible}
      header={t('Account Locked')}
    >
      <Inscription margin={{ top: 'spacing12' }}>
        {t(`Your account has been locked due to failed login attempts. You can try again in ${lockingLeft} minutes.`)}
      </Inscription>
    </WarnModal>
  );
};

export default AccountLockoutModal;
